import React, { useState } from 'react'

export default function EsgDashboards() {
  const [loading, setLoading] = useState(true);
  return (
    <>


      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          {loading ? <h1 className="h2"><i class="fa-solid fa-spinner fa-spin"></i></h1> : <h1 className="h2">ESG Dashboards</h1>}

        </div>
        <div>

          {/* <iframe
            src="https://lookerstudio.google.com/embed/reporting/a974e78e-f751-476f-ad9f-06288ddbc0fe/page/9yatD"
            onLoad={() => setLoading(false)}
            width={'1225'}
            height={'1000'}
            style={{ display: loading ? 'none' : 'block' }}
          /> */}
          <iframe
            width={"1225"}
            height={"1000"}
            src="https://lookerstudio.google.com/embed/reporting/a974e78e-f751-476f-ad9f-06288ddbc0fe/page/9yatD"
            onLoad={() => setLoading(false)}
            style={{ display: loading ? 'none' : 'block' }}
            allowFullScreen
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
          ></iframe>
        </div>
      </main>
    </>
  )
}
